import { render } from "./CustomerListPage.vue?vue&type=template&id=71e949a0&ts=true"
import script from "./CustomerListPage.vue?vue&type=script&lang=ts"
export * from "./CustomerListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__